// @flow

import type { SiteMetadata$Config } from '../src/plugins/site/types';

const newDate = require('../src/helpers/newDate');

/* GatsbyStarterConfig: site metadata */
module.exports = ({
  siteName: 'Origen Studio - Gatsby Starter',
  siteUrl: `https://gatsby-starter.origen.studio`,
  title: `Gatsby Starter by Origen Studio`,
  description: `Project starter for most of the Gatsby projects we do in Origen Studio`,
  author: {
    name: `Origen Studio <hello@origen.studio>`,
    email: `hello@origen.studio`,
  },
  image: {
    url: 'https://gatsby-starter.origen.studio/gatsby-icon.png', // acts as default image
    alt: 'brand image',
    width: '512',
    height: '512',
  },
  organization: {
    name: `Origen Studio`,
    url: `https://origen.studio`,
    email: `hello@origen.studio`,
    logo: {
      url: 'https://gatsby-starter.origen.studio/gatsby-icon.png', // acts as default image
      alt: 'brand image',
      width: '512',
      height: '512',
    },
  },

  datePublished: newDate().toISOString(),
  dateModified: newDate().toISOString(),
  social: {
    twitter: '@TheOrigenStudio',
    fbAppID: '2428024380772108', // real app ID for the Origen Studio Gatsby Starter
  },
  baseCookieKey: 'gatsby-starter-default',
}: SiteMetadata$Config);
